import { connect } from 'react-redux';
import React from 'react';
import { bindActionCreators } from 'redux';
import { KBButton, KBPopover, KBForm } from 'components';
import { lockerCategoriesAction } from 'app/actions';
import { api } from 'app/services';
import * as valid from 'utils/validate';
import intl from 'react-intl-universal';
import { renderKBInput, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';

var LockerCategoryForm = class extends React.Component {constructor(props) {super(props);this.createLockerCategory = this.createLockerCategory.bind(this);}createLockerCategory(
  model) {
    const {
      location_id,
      createLockerCategoriesAction,
      updateLockerCategoriesAction,
      type,
      category } =
    this.props;

    if (type == 'update') {
      return api.
      putLockerCategories(category.id, { location_id, ...model }).
      then(
      json => {
        updateLockerCategoriesAction.success(json);
        KBPopover.close();
      },
      error => {
        updateLockerCategoriesAction.failure(error);
      });

    }

    return api.postLockerCategories({ location_id, ...model }).then(
    json => {
      createLockerCategoriesAction.success(json);
      KBPopover.close();
    },
    error => {
      createLockerCategoriesAction.failure(error);
    });

  }render()

  {
    const {
      fields: { name, price, capacity },
      handleSubmit,
      submitting,
      type,
      currency } =
    this.props;
    return (
      <KBForm
      type="reduxForm"
      onSubmit={handleSubmit(this.createLockerCategory)}>

        <header className="kb-form-header">
          <h2 className="header-title">
            {type == 'update' ? '修改规格' : '添加规格'}
          </h2>
          <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopover.close} />

        </header>
        <div className="kb-form-container">
          <div className="kb-row">
            <Field name="name" component={renderKBInput}
            className="kb-form-group kb-form-c18 kb-form-alone"

            title="规格名称"
            isRequired={true} />

          </div>
          <div className="kb-row">
            <Field name="price" component={renderKBInput}
            className="kb-form-group kb-form-c18 kb-form-alone"

            title={`价格(${currency}/分钟)`}
            isRequired={true}
            type="number" />

          </div>
          <div className="kb-row">
            <Field name="capacity" component={renderKBInput}
            className="kb-form-group kb-form-c18 kb-form-alone"

            title="柜体容量/L"
            isRequired={true}
            type="number" />

          </div>
          <div className="kb-row fixed-form-btn">
            <span className="cancel-btn" onClick={KBPopover.close}>
              取消
            </span>
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              确定
            </KBButton>
          </div>
        </div>
      </KBForm>);

  }};


function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    createLockerCategoriesAction: bindActionCreators(
    lockerCategoriesAction.create,
    dispatch),

    updateLockerCategoriesAction: bindActionCreators(
    lockerCategoriesAction.update,
    dispatch) };


}

const validate = values => {
  const errors = {};

  if (valid.required(values.name)) {
    errors.name = '请输入规格名称';
  }

  if (valid.required(values.price)) {
    errors.price = '请输入价格';
  }

  return errors;
};

const LEGACY_FORM_FIELDS = [
  "name",
  "price",
  "capacity"
];

const formConfig = {
  form: 'LockerCategoryForm',
  validate: validate,
  touchOnBlur: false };


LockerCategoryForm = connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('LockerCategoryForm', LEGACY_FORM_FIELDS)(LockerCategoryForm)));

export default LockerCategoryForm;
